import { Component, Input, input } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { SharedDataService } from '../services/shared-data.service';
import { IdInversorService } from '../services/id-inversor.service';
import { SettingsService } from '../../settings/settings.service';
import { MaterialModule } from '../../material/material.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pdf-simulacion',
  standalone: true,
  imports: [MaterialModule, CommonModule],
  templateUrl: './pdf-simulacion.component.html',
  styleUrl: './pdf-simulacion.component.less'
})
export class PdfSimulacionComponent {
  @Input() stepper!: MatStepper;

  emailAddress$: any;
  enviandoBtn = false;

  constructor(
    private idInversorService: IdInversorService,
    private settings: SettingsService,
  ){
  }

  async downloadPdf() {
    this.enviandoBtn = true;
    try {
      const investorId = this.idInversorService.getIdInversor();
      if (investorId) {
        const response: any = await this.settings.get_query(2, `/cliente-inversionista/simulation-pdf/${investorId}/`, {}, true);
        const downloadUrl = response._body.file;
        window.open(downloadUrl, '_blank');
      } else {
        console.error('ID de inversor no válido.');
      }
    } catch (error) {
      console.error('Error en la solicitud para descargar el PDF:', error);
    } finally {
      this.enviandoBtn = false;
    }
  }

  nuevaSimulacion() {
    window.location.reload();
  }
}